export default __webpack_public_path__ + "images/3f00485f8e5edb061e2a5849be32c197.svg";